// extracted by mini-css-extract-plugin
export default {"toggleContainer":"Toggle_toggleContainer__qQgk3","thumb":"Toggle_thumb__ZdlFe","option":"Toggle_option__wUcEw","active":"Toggle_active__xDU+j"};